import React from "react";
import { DateRangePicker, isInclusivelyBeforeDay } from "react-dates";
import moment from "moment";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

type DateTypes = "startDate" | "endDate" | null;
type InputDate = moment.Moment | null;

interface Props {
  onClick: (startDate: InputDate, endDate: InputDate) => void;
  start: string;
  end: string;
}

interface Input {
  startDate: InputDate;
  endDate: InputDate;
}

type Action =
  | { type: "SET_DATE"; startDate: InputDate; endDate: InputDate }
  | { type: "SET_FOCUSED"; focusedInput: DateTypes };

interface State {
  startDate: InputDate;
  endDate: InputDate;
  focusedInput: DateTypes;
}

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "SET_DATE":
      const { startDate, endDate } = action;

      return {
        ...state,
        startDate,
        endDate,
      };
    case "SET_FOCUSED":
      const { focusedInput } = action;

      return {
        ...state,
        focusedInput,
      };
  }
}

function DatePicker({ onClick, start, end }: Props) {
  const [form, dispatch] = React.useReducer(reducer, {
    startDate: moment(start),
    endDate: moment(end),
    focusedInput: null,
  });

  const { startDate, endDate, focusedInput } = form;

  const onDatesChange = (args: Input) => {
    const { startDate, endDate } = args;
    dispatch({ type: "SET_DATE", startDate, endDate });
    onClick(startDate, endDate);
  };

  const setFocusedInput = (input: DateTypes) => {
    dispatch({ type: "SET_FOCUSED", focusedInput: input });
  };

  return (
    <DateRangePicker
      numberOfMonths={1}
      minimumNights={0}
      displayFormat={() => "DD/MM/YYYY"}
      isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
      startDateId="startDate"
      endDateId="endDate"
      startDate={startDate}
      endDate={endDate}
      onDatesChange={onDatesChange}
      focusedInput={focusedInput}
      onFocusChange={setFocusedInput}
    />
  );
}

export default DatePicker;
